import React from 'react';
import { Box, Popover } from 'wix-style-react';
import { ContactOwnerButton } from './ContactOwnerButton/ContactOwnerButton';
import { Text } from '../../../../../PageElements/Text';

export const ContactOwnerButtonContainer = ({
  isTooltipOpen,
  onMouseEnter,
  onMouseLeave,
  onClick,
  isSelectedMode,
}) => {
  return (
    <span>
      <Box align="center" verticalAlign="middle">
        <Popover
          dataHook="contact-owner-popover"
          shown={isTooltipOpen}
          flip={false}
          animate
          appendTo="window"
          showArrow
          placement="top"
          moveBy={{ y: 5 }}
        >
          <Popover.Element>
            <ContactOwnerButton
              onClick={onClick}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              isSelectedMode={isSelectedMode}
            />
          </Popover.Element>
          <Popover.Content>
            <Box padding="10px 16px">
              <Text size="small" tagName="span">
                Contact Owner
              </Text>
            </Box>
          </Popover.Content>
        </Popover>
      </Box>
    </span>
  );
};
